import { lazy, Suspense } from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageLoader } from '@/components/common/PageLoader';

function LazyPage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

const SettingsPage = lazy(() => import('@/pages/SettingsPage'));
const WorkflowEnginePage = lazy(() => import('@/pages/settings/WorkflowEnginePage'));
const DesignGalleryPage = lazy(() => import('@/pages/design/DesignGalleryPage'));
const UserManagementPage = lazy(() => import('@/pages/users/UserManagementPage'));
const AuditLogPage = lazy(() => import('@/pages/users/AuditLogPage'));

// Template Pages
const TemplateBuilderPage = lazy(() => import('@/pages/template/TemplateBuilderPage'));
const GenerateReportPage = lazy(() => import('@/pages/template/GenerateReportPage'));
const ReportConfigurationPage = lazy(() => import('@/pages/template/ReportConfigurationPage'));
const ManageTemplatesPage = lazy(() => import('@/pages/template/ManageTemplatesPage'));

export default function SettingsRoutes() {
  return (
    <>
      {/* Settings */}
      <Route path="/settings" element={<ProtectedRoute><MainLayout><LazyPage><SettingsPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/settings/workflow-engine" element={<ProtectedRoute><MainLayout><LazyPage><WorkflowEnginePage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/design/gallery" element={<ProtectedRoute><MainLayout><LazyPage><DesignGalleryPage /></LazyPage></MainLayout></ProtectedRoute>} />

      {/* User Management */}
      <Route path="/users/admin" element={<ProtectedRoute><MainLayout><LazyPage><UserManagementPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/users/audit" element={<ProtectedRoute><MainLayout><LazyPage><AuditLogPage /></LazyPage></MainLayout></ProtectedRoute>} />

      {/* Template Routes */}
      <Route path="/template" element={<ProtectedRoute><Navigate to="/template/builder" replace /></ProtectedRoute>} />
      <Route path="/template/builder" element={<ProtectedRoute><MainLayout><LazyPage><TemplateBuilderPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/template/configure" element={<ProtectedRoute><MainLayout><LazyPage><ReportConfigurationPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/template/generate" element={<ProtectedRoute><MainLayout><LazyPage><GenerateReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/template/manage" element={<ProtectedRoute><MainLayout><LazyPage><ManageTemplatesPage /></LazyPage></MainLayout></ProtectedRoute>} />
    </>
  );
}
